import React, { createContext } from "react";

import userReducer from "./fetcher.reducer";
import { createStore } from "..";
import { apis } from "../../utils/apis";
import { statlerUIAnalyticsProvider } from "../../utils/Analytics";

export const createApiStates = apiMap => {
    const mappedApis = {};
    for (const key in apiMap) {
        mappedApis[key] = {
            loading: false,
            error: null,
            data: {},
            ...apiMap[key],
        };
    }
    return mappedApis;
};

export const FetchCtx = createContext({});

export const FetchProvider = ({ client, children }) => {
    const apiDefinitions = apis(client.globals);
    const INITIAL_STATE = createApiStates(apiDefinitions);
    const store = createStore(userReducer, INITIAL_STATE);
    statlerUIAnalyticsProvider.addEndpoint(apiDefinitions.SendClientLogs.baseUrl)

    client.addDispatch(store.dispatch).addApiDefinitions(apiDefinitions);
    return (
        <FetchCtx.Provider value={{ fetch: client.fetch, state: store.state }}>
            {children}
        </FetchCtx.Provider>
    );
};
